module.exports = __webpack_public_path__ + "img/fb.dc79ad5e.png";